module.exports = __webpack_public_path__ + "static/media/Looks-like-you-choked.13f673b1.jpg";